module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form"
  }, [_c('el-dialog', {
    attrs: {
      "title": "选择部门",
      "size": "tiny"
    },
    model: {
      value: (_vm.actionPartmentVisible),
      callback: function($$v) {
        _vm.actionPartmentVisible = $$v
      },
      expression: "actionPartmentVisible"
    }
  }, [_c('Tree', {
    ref: "tree",
    attrs: {
      "message": _vm.TreeDataList
    },
    on: {
      "NodeClick": _vm.handleActionPartment
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.actionPartmentVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.sureBtn
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-36bfc764!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Agent/AddEmployee/components/chooseDept/index.vue
// module id = 1448
// module chunks = 1